import { mainShowTypes, subShowTypes } from '~/features/guide/GuideRestaurantInfo'
import { RestaurantMainInfo, RestaurantSubInfo } from '~/features/info/RestaurantInfo'
import { useRestaurantInfo } from '~/features/reservationInput/store/stateMachine/state'
import { css } from '~/styled-system/css'
import { CollapsibleContainer, type VariantsProps } from './CollapsibleContainer'

export function RestaurantInfo(variants: VariantsProps) {
  const restaurant = useRestaurantInfo()
  if (!restaurant) {
    return null
  }
  return (
    <CollapsibleContainer title="店舗情報" {...variants}>
      <div
        className={css({
          py: '2',
          dsY: '3',
          divideY: 'thin',
          divideColor: 'gray.300',
          divideStyle: 'dashed',
        })}
      >
        <RestaurantMainInfo restaurant={restaurant} showTypes={mainShowTypes('planModal')} />
        <RestaurantSubInfo restaurant={restaurant} showTypes={subShowTypes('planModal')} />
      </div>
    </CollapsibleContainer>
  )
}
